
import dayjs from 'dayjs' //日期时间处理组件
const fmt ={
dateFormat:function (dateStr,pattern='YYYY-MM-DD'){
    if (!dateStr)
        return "";
    else if (!dayjs(dateStr).isValid())
        return dateStr;
    return dayjs(dateStr).format(pattern);
},

DiffDays:function (date1, date2){
    //计算2个日期的天数差（需要补充工作日、调休的修改）
    const diffInDays = dayjs(date2).diff(date1, 'days');
    return diffInDays;
},
fmtBorrowStatus:function (item, row, column){
    if (row.DMOAUnNum>0)
        return'待科室审批';
    if (row.ConfirmResult==null)
        return'待病案科审批';
    if (row.ConfirmResult == 0)
        return '已驳回';
    if(row.MedicalType == 1)    //电子版的，已同意，则自动未借阅中
        return  dayjs(row.PlanReturnDtime).format('YYYYMMDD') >= dayjs().format('YYYYMMDD')?'借阅中':'已收回';
    //原件的：
    if(row.SignDtime==null)
        return '待签字领取'
    if(row.ReturnDtime !=null ){    //说明已归还
        return dayjs(row.ReturnDtime).format('YYYYMMDD') <= dayjs(row.PlanReturnDtime).format('YYYYMMDD') ?'已归还':'超期归还'
    }
    if (row.PlanReturnDtime < dayjs().format())//??电子版借阅不存在超期未归...
        return '超期未归还';
    else if(row.SignDtime != null)
        return '借阅中';
    else 
        return '待签字领取2';//理论不会到这个else
},
fmtFileUrlByID:function (medicalID){
    let urls = sys.fileUrlList;
    let url = urls[0].filePath
    for(let m in urls) {
        if(medicalID<=m.maxID){
            url=m.filePath;
            break;
        }
        else url=m.filePath
     }
    return url;
},


//item: viewCell对应的某1列， row,对应的行数据，col：对应的列数据
mapFormat:function (item, row, col){
    let _mapName = item.fmt.mapName || item.field;
    if (!config[_mapName] || !config[_mapName].get(row[col.field]+''))
        return '';
    let flag = item.fmt.flag || Object.keys(config[_mapName].get(row[col.field]+''))[0];
    return config[_mapName].get(row[col.field]+'')[flag];
},

//这个需要改写。
autoFormat:function (itemValue, fmtStr){
    if(!fmtStr || fmtStr=='')
        return itemValue;
    else if (typeof(fmtStr) == 'number' && typeof(itemValue) == 'number')
        return itemValue.toFixed(fmtStr);
    else if(fmtStr=='TrueFalse')
        return itemValue==0?'否':'是';
    return (fmtStr && dayjs(itemValue).isValid())?dayjs(itemValue).format(fmtStr):itemValue;
},
//不区分大小写，不修改原对象属性，只赋值属性值。
convertObj:function (target,source){
    for (let key1 in target) {
      for (let key2 in source){
        if (key1.toLocaleLowerCase() == key2.toLocaleLowerCase()){
          target[key1] = source[key2];
          break;
        }
      }
    }
    return target;
},
//保持原对象去重（不是通过创建新对象来去重，比如Array.from(new Set(arr))）,能保持vxetable内的数据状态不变；
removeSameObj:function (arrays, key){
    let obj = {};
    return arrays.reduce(function(item, next) {
        obj[next[key]] ? '' : obj[next[key]] = true && item.push(next);
        return item;;
    }, []);
},

fmtWorkDays:function (item, row, column){
    let _fieldValue = row[column.field];
    if(!_fieldValue)
        return '';
    if(_fieldValue > config.OverdueDays)
        return `<font color='red'><b>${_fieldValue}</b></font>工作日`;
    return _fieldValue+'工作日';
},

//将含有父子关系的表解构转换为树结构
formatToTree:function (Arr, attName, pAttName) {
    let treeList = Arr.reduce((prev,cur)=>{prev[cur[attName]] = cur; return prev },{})
    let result = Arr.reduce((prev,cur)=>{
        let pid = cur[pAttName];
        let parent = treeList[pid]
        if(parent)
            parent.children? parent.children.push(cur) : parent.children = [cur]
        else
            prev.push(cur)  //没有父对象，则默认为根元素
        return prev
    },[])
    return result;
},

//递归按顺序获取TREE中的所有节点
getAllTreeNodes:function (treeData) {
    let allNodes = [];
    function traverse(nodes) {
        nodes.forEach(node => {
            allNodes.push(node); // 添加当前节点到结果数组
            if (node.children && node.children.length > 0) 
                traverse(node.children); // 递归遍历子节点
        });
    }
    traverse(treeData);
    return allNodes;
},
blobToArrayBuffer:function (blob) {
    if (!blob || !(blob instanceof Blob)) {
        console.log('blobToArrayBufferblob',blob);
        return Promise.reject(new TypeError("Invalid Blob object"));
    }
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function() {
        const arrayBuffer = reader.result;
        resolve(arrayBuffer);
        };
        reader.onerror = function(error) {
        reject(error);
        };
        reader.readAsArrayBuffer(blob);
    });
},
randomUUID:function () {
    const hexDigits = '0123456789abcdef';
    let uuid = '';

    for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid += '-';
        } else if (i === 14) {
            uuid += '4';
        } else if (i === 19) {
            uuid += hexDigits[(Math.floor(Math.random() * 4) + 8)];
        } else {
            uuid += hexDigits[Math.floor(Math.random() * 16)];
        }
    }
    return uuid;
}
};
// export default {
//     dateFormat, autoFormat, convertObj, removeSameObj, mapFormat, formatToTree,
//     DiffDays, fmtWorkDays, fmtBorrowStatus,fmtFileUrlByID, getAllTreeNodes,blobToArrayBuffer,randomUUID
// }
export default fmt;


// WEBPACK FOOTER //
// ./src/utils/fmt.js